import styled from 'styled-components';
import { Skeleton } from '#/shared/components/Skeletons/styled';

export const TripTopSkeletonWrapper = styled.div`
  background: ${props => `${props.theme.tripTopSkeleton}`};
  display: grid;
  padding: 0 1em;
  min-height: 190px;
`;

export const TripStepSkeletonWrapper = styled.div`
  background: ${props => `${props.theme.tripStepSkeleton}`};
  padding-bottom: 2rem;
  height: 100%;
  overflow: hidden;
  margin-left: 63px;
`;

export const TripTopSkeletonTopHeadWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 0.5rem;
`;

export const TripStepSkeletonTopWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 0.5rem;
  align-items: center;
  background: ${props => `${props.theme.tripStepSkeleton}`};
`;

export const TripTopSkeletonTopFootWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  background: ${props => `${props.theme.tripTopSkeleton}`};
`;

export const TripStepSkeletonMembers = styled.div`
  display: flex;
  justify-content: left;
  margin-bottom: 1em;
  transform: ${props => props.transformProp};
`;

export const MiniCircleWrapper = styled.div`
  position: relative;
  height: 100%;
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-left: ${props => `1px solid ${props.theme.skeletonBaseColor}`};
    height: ${props => props.trailingLineHeight};
    top: ${props => (props.top ? '1rem' : '-1rem')};
    border: ${props => `solid 3px ${props.theme.skeletonBaseColor}`};
  }
`;

export const TripTopSkeletonTopHead = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
}))`
  && {
    background: ${props => props.theme.tripTopSkeletonTop};
  }
`;

export const TripTopSkeletonTopFoot = styled(Skeleton).attrs(() => ({
  circle: true,
  enableAnimation: false,
  width: '32px',
  height: '32px',
}))`
  && {
    background: ${props => props.theme.tripTopSkeletonTop};
  }
`;

export const MiniCircleSkeleton = styled(Skeleton).attrs(() => ({
  circle: true,
  containerClassName: 'skeleton-flex-0',
  enableAnimation: false,
  width: '32px',
  height: '32px',
}))``;

export const TripStepSeparatorSkeleton = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
}))``;

export const TripStepSkeletonOne = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
}))`
  max-width: 30%;
  transform: translateX(50%);
`;

export const TripStepSkeletonTwo = styled(Skeleton).attrs(() => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex-1',
}))`
  max-width: 40%;
  transform: translateX(37%);
`;
